export default "__VITE_ASSET__DaFnbvCo__"